export default function Footer() {
    return (
        <footer>CREATED WITH THE <a className='footer-link' href='https://harvardartmuseums.org/collections/api' title='HARVARD ART MUSEUMS API'>HARVARD ART MUSEUMS API</a></footer>
    )
}

